import React, { useState, useEffect } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Dashboard from "../pages/common/Dashboard";
import FeaturedForm from "../pages/common/FeaturedForm";
import Withdraw from "../pages/Fundraiser/Withdraw";
import AddBank from "../pages/Fundraiser/AddBank";
import BanksList from "../pages/Fundraiser/BanksList";
import FundraiserReferralList from "../pages/Fundraiser/FundraiserReferralList";
import ReferForm from "../pages/Fundraiser/ReferForm";
import Assets from "../pages/Fundraiser/Assets";
import Marketing from "../pages/Fundraiser/Marketing";
import FundraiserGettingStarted from "../pages/Fundraiser/GettingStarted";
import FundraiserCreateAccount from "../pages/Fundraiser/CreateAccount";
import FundraiserAccountCreated from "../pages/Fundraiser/AccountCreated";
import FundraiserAccountLogin from "../pages/Fundraiser/AccountLogin";
import FundraiserSetUpAccount from "../pages/Fundraiser/SetUpAccount";
import Welcome from "../pages/common/Welcome";
import MerchantOnboardLayout from "../components/Merchant/MerchantOnboarding/MerchantOnboardLayout";
import { useSelector } from "react-redux";
import PrivateRoute from "./PrivateRoute";
import Transactions from "../pages/Fundraiser/Transactions";
import EditProfileForm from "../pages/Fundraiser/EditProfileForm";
import MerchantVisibility from "../pages/Fundraiser/MerchantVisibility";
import FundraiserBrand from "../pages/User/FundraiserBrand";
import FundraiserComingSoon from "../components/Fundraiser/FundraiserComingSoon";

const FundraiserRoutes = () => {
  const token = useSelector((state) => state?.authReducer?.tokenData?.token);
  const user = useSelector((state) => state?.authReducer?.tokenData?.user);
  const role = useSelector(
    (state) => state?.authReducer?.tokenData?.user?.role
  );
  const tokenData = useSelector((state) => state?.authReducer?.tokenData);

  const [isAuthenticated, setIsAuthenticated] = useState(!!token);
  const normalizedRole = typeof role === "string" ? role.toLowerCase() : role;
  const isRoleMatching = isAuthenticated && normalizedRole === "fundraiser";
  
  const getRedirectPath = () => {
    switch (normalizedRole) {
      case "admin":
        return "/admin/dashboard";
      case "merchant":
        return "/merchant/dashboard";
      case "fundraiser":
        return "/fundraiser/dashboard";
      case "user":
      case "member":
        return "/";
      default:
        return "/";
    }
  };

  useEffect(() => {
    console.log('🔍 [FundraiserRoutes] Checking auth...', { 
      token: !!token, 
      role,
      isRoleMatching 
    });
    setIsAuthenticated(!!token);
  }, [token, role]);

  return (
    <Routes>
      <Route
        path="dashboard"
        element={
          <PrivateRoute
            element={
              <FeaturedForm
                element={
                  isRoleMatching ? (
                    <Dashboard />
                  ) : (
                    <Navigate to={getRedirectPath()} />
                  )
                }
              />
            }
          />
        }
      />
      <Route
        path="transactions"
        element={
          <FeaturedForm
            element={
              isRoleMatching ? (
                <Transactions />
              ) : (
                <Navigate to={getRedirectPath()} />
              )
            }
          />
        }
      />
      <Route
        path="withdraw"
        element={
          <FeaturedForm
            element={
              isRoleMatching ? (
                <Withdraw />
              ) : (
                <Navigate to={getRedirectPath()} />
              )
            }
          />
        }
      />
      <Route
        path="add-bank"
        element={
          <FeaturedForm
            element={
              isRoleMatching ? <AddBank /> : <Navigate to={getRedirectPath()} />
            }
          />
        }
      />
      <Route
        path="banks-list"
        element={
          <FeaturedForm
            element={
              isRoleMatching ? (
                <BanksList />
              ) : (
                <Navigate to={getRedirectPath()} />
              )
            }
          />
        }
      />
      <Route
        path="refer-merchant"
        element={
          <FeaturedForm
            element={
              isRoleMatching ? (
                <ReferForm />
              ) : (
                <Navigate to={getRedirectPath()} />
              )
            }
          />
        }
      />
      <Route
        path="referral-list"
        element={
          <FeaturedForm
            element={
              isRoleMatching ? (
                <FundraiserReferralList />
              ) : (
                <Navigate to={getRedirectPath()} />
              )
            }
          />
        }
      />
      <Route
        path="merchant-visibility"
        element={
          <FeaturedForm
            element={
              isRoleMatching ? (
                <MerchantVisibility />
              ) : (
                <Navigate to={getRedirectPath()} />
              )
            }
          />
        }
      />
      <Route
        path="edit-profile"
        element={
          <FeaturedForm
            element={
              isRoleMatching ? (
                <EditProfileForm />
              ) : (
                <Navigate to={getRedirectPath()} />
              )
            }
          />
        }
      />
      <Route
        path="assets"
        element={
          <FeaturedForm
            element={
              isRoleMatching ? <Assets /> : <Navigate to={getRedirectPath()} />
            }
          />
        }
      />
      <Route
        path="marketing"
        element={
          <FeaturedForm
            element={
              isRoleMatching ? (
                <Marketing />
              ) : (
                <Navigate to={getRedirectPath()} />
              )
            }
          />
        }
      />
      <Route
        path="welcome"
        element={
          isRoleMatching ? <Welcome /> : <Navigate to={getRedirectPath()} />
        }
      />
      <Route
        path="getting-started"
        element={
          <MerchantOnboardLayout
            element={
              !isAuthenticated ? (
                <FundraiserGettingStarted />
              ) : (
                <Navigate to={getRedirectPath()} />
              )
            }
          />
        }
      />
      <Route
        path="resubmit/:token"
        element={
          <MerchantOnboardLayout
            element={
              !isAuthenticated ? (
                <FundraiserGettingStarted mode="resubmit" />
              ) : (
                <Navigate to={getRedirectPath()} />
              )
            }
          />
        }
      />
      <Route
        path="account-setup"
        element={<FundraiserSetUpAccount />}
      />
      <Route
        path="create-account"
        element={
          <MerchantOnboardLayout element={<FundraiserCreateAccount />} />
        }
      />
      <Route
        path="welcome-onboard/:verificationCode"
        element={
          <MerchantOnboardLayout element={<FundraiserCreateAccount />} />
        }
      />
      <Route
        path="setup/:verificationCode"
        element={
          <MerchantOnboardLayout element={<FundraiserCreateAccount />} />
        }
      />
      <Route
        path="account-created"
        element={
          <MerchantOnboardLayout element={<FundraiserAccountCreated />} />
        }
      />
      <Route path="coming-soon" element={<FundraiserComingSoon />} />
      <Route
        path="account-login"
        element={
          <MerchantOnboardLayout element={<FundraiserAccountLogin />} />
        }
      />
      <Route path=":id" element={<FundraiserBrand />} />
      <Route path="*" element={<Navigate to={isRoleMatching ? "/fundraiser/dashboard" : getRedirectPath()} replace />} />
    </Routes>
  );
};

export default FundraiserRoutes;
